import { Page } from '../Components';

export const PageLoadFallback = () => (
    <Page>
        <Page.Content fullWidth>Loading...</Page.Content>
    </Page>
);
